import { HighlightColorsEnum } from '../enums';

export const hightlightColorsAlpha: Record<HighlightColorsEnum, string> = {
  [HighlightColorsEnum.YELLOW]: 'rgb(254, 219, 0, 0.4)',
  [HighlightColorsEnum.BLUE]: 'rgb(145, 205, 250, 0.4)',
  [HighlightColorsEnum.PINK]: 'rgb(247, 153, 222, 0.4)',
};
